import React from 'react';

import EventsRegisterSearchRoute from 'routes/Events/RegisterSearch';
import EventsOrdersRoute from 'routes/Events/Orders';
import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/:id',
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'eventsStoreRidesInfo' */ './component')],
			render: ([EventsStoreRidesInfo]) => <EventsStoreRidesInfo />,
		},
		{
			path: '/reservation',
			components: () => [
				import(/* webpackChunkName: 'eventsStoreRidesReservation' */ './reservation'),
			],
			render: ([EventsStoreRidesReservation]) => <EventsStoreRidesReservation />,
		},
		EventsRegisterSearchRoute,
		EventsOrdersRoute,
	],
};

export default routes;
